<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <button class="add-ticket" data-toggle="modal" data-target="#exampleModal">Add Vendor</button>
  
            <div class="personal-details">
                <h4 class="personal-details-title">Vendor Master</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Vendor Name</th>
                      <th scope="col">Vendor Description</th>
                      <th scope="col">Vendor Code</th>
                      <th scope="col">Vendor Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let x of product | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: pageNumber,
                      totalItems: totalRecords
                    };let i = index">
                      <th scope="col">{{i+1}}</th>
                      <th scope="col">{{x.name}}</th>
                      <th scope="col">{{x.description}}</th>
                      <th scope="col">{{x.code}}</th>
                      <th scope="col">{{x.latestStatus}}</th>
                    </tr>
                       
                  </tbody>
              </table>
              <div class="pagination-block" *ngIf="product.length != 0">
                <pagination-controls
                previousLabel="Prev"
                nextLabel="Next"
                (pageChange)="onTableDataChange($event)">
                </pagination-controls>
              </div>
            </div>
  
        </div>
    </div>
</div>
  
  
<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Vendor
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
  
        <div [formGroup]="form">
  
            <div class="form-group">
                <label>Vendor Name</label>
                <input formControlName="name" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label>Vendor Description</label>
                <input formControlName="description" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label>Vendor Code</label>
                <input formControlName="code" type="text" class="form-control">
            </div>
  
            <div class="form-group">
                <label>Vendor Version</label>
                <input formControlName="version" type="text" class="form-control">
            </div>
  
            <!-- <div class="form-group">
                <label>Active status</label>
                <input  type="checkbox" formControlName="isActive" class="form-control">
            </div> -->
  
        </div>
  
   
      <div class="modal-footer">
        <button type="button" id="closeModalButton"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="addVendor()" class="btn btn-primary">Add Vendor</button>
      </div>
    </div>
  </div>
  </div>
</div>
